import { createSlice } from "@reduxjs/toolkit";
import {
    getChat,
    deleteChat,
    getChatDetail,
    sendMessage,
    updateStatusMessage,
    changeAISuggestion,
    createActivityNotes,
    changeDisplayNotes,
} from './thunk';

export const initialState = {
    chats: [],
    chatDetail: {} as any,
    errors: {},
    loading: false,
};

const ChatSlice = createSlice({
    name: 'Chat',
    initialState,
    reducers: {
        receiveMessage: (state: any, action: any) => {
            if (!action || !action.payload) {
                return;
            }
            const newMessage = action.payload;
            const chatIndex = state.chats.findIndex((chat: any) => chat.id === newMessage.conversationId);
            if (chatIndex !== -1) {
                const chat = state.chats[chatIndex];
                chat.lastMessageContent = newMessage.content;
                chat.lastMessageDateTime = new Date();
                chat.unreadMessageCount = newMessage.isClientMessage ? (chat.unreadMessageCount || 0) + 1 : (chat.unreadMessageCount || 0);
                chat.statusMessage = chat.unreadMessageCount > 0 ? 'UnRead' : 'Read';

                // Move the updated chat to the top of the list
                state.chats.splice(chatIndex, 1);
                state.chats.unshift(chat);
            } else {
                // Add new chat to the top of the list
                const newChat = {
                    id: newMessage.conversationId,
                    lastMessageContent: newMessage.content,
                    lastMessageDateTime: new Date(),
                    unreadMessageCount: newMessage.isClientMessage ? 1 : 0,
                    statusMessage: newMessage.isClientMessage ? 'UnRead' : 'Read',
                    name: newMessage.contactName || 'Unknown',
                    messages: [...newMessage ? [newMessage] : []],
                };
                state.chats.unshift(newChat);
            }

            if (state.chatDetail?.id === newMessage.conversationId && !state.chatDetail?.messages.some((msg: any) => msg.id === newMessage.id)) {
                state.chatDetail = {
                    ...state.chatDetail,
                    messages: [...state.chatDetail.messages, newMessage],
                };
            }
        }
    },
    extraReducers: (builder) => {
        console.log('builder');
        builder.addCase(getChat.pending, (state: any, action: any) => {
            state.loading = true;
        });
        builder.addCase(getChat.fulfilled, (state: any, action: any) => {
            state.chats = action.payload;
            state.loading = false;
        });
        builder.addCase(getChat.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
            state.loading = false;
        });
        builder.addCase(getChatDetail.pending, (state: any, action: any) => {
        });
        builder.addCase(getChatDetail.fulfilled, (state: any, action: any) => {
            state.chatDetail = action.payload;
        });
        builder.addCase(getChatDetail.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(sendMessage.pending, (state: any, action: any) => {
        });
        builder.addCase(sendMessage.fulfilled, (state: any, action: any) => {
            if (!action || !action.payload) {
                return;
            }
            state.chatDetail = { ...state.chatDetail, messages: [...state.chatDetail.messages, action.payload] };
            let chats = [...state.chats]
            let firstChat = chats.find(c => c.id === action.payload.conversationId);
            if (!!firstChat) {
                firstChat.lastMessageContent = action?.payload?.content;
                firstChat.lastMessageDateTime = new Date();
                let otherChat = chats.filter(c => c.id !== action.payload.conversationId);
                let orderedChat = [firstChat, ...otherChat];

                state.chats = orderedChat;
            }
        });
        builder.addCase(sendMessage.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(updateStatusMessage.pending, (state: any, action: any) => {
        });
        builder.addCase(updateStatusMessage.fulfilled, (state: any, action: any) => {
            if (!action || !action.payload) {
                return;
            }
            let chats = [...state?.chats]
            let currentChat = chats.find(c => c.id === action.payload.conversationId);
            if (!!currentChat) {
                currentChat.lastMessageContent = action?.payload?.content;
                // currentChat.lastMessageDateTime = new Date(action?.payload?.creationTime);
                currentChat.statusMessage = 'Read';
                currentChat.unreadMessageCount = 0;
            }

            state.chats = chats;
        });
        builder.addCase(updateStatusMessage.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(changeAISuggestion.pending, (state: any, action: any) => {
        });
        builder.addCase(changeAISuggestion.fulfilled, (state: any, action: any) => {
            state.chatDetail.enableSuggestion = action.payload.enableSuggestion;
        });
        builder.addCase(changeAISuggestion.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(changeDisplayNotes.pending, (state: any, action: any) => {
        });
        builder.addCase(changeDisplayNotes.fulfilled, (state: any, action: any) => {
            state.chatDetail.isHideNotes = action.payload.isHideNotes;
        });
        builder.addCase(changeDisplayNotes.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });



        builder.addCase(deleteChat.pending, (state: any, action: any) => {
        }); builder.addCase(deleteChat.fulfilled, (state: any, action: any) => {
            state.chats = (state.chats || []).filter((chat: any) => chat.id !== action.payload);
            if (state.chatDetail?.id === action.payload) {
                state.chatDetail = {};
            }
        });
        builder.addCase(deleteChat.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        // Create Activity Notes
        builder.addCase(createActivityNotes.pending, (state: any, action: any) => {
        });
        builder.addCase(createActivityNotes.fulfilled, (state: any, action: any) => {
            state.chatDetail = action.payload;
        });
        builder.addCase(createActivityNotes.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export const { receiveMessage } = ChatSlice.actions;

export default ChatSlice.reducer;